<template>
<span class="sched-app-pref-icons">
  <span>
    <i class="material-icons" @click="toggleView">
      playlist_add
    </i>
    <router-link to="/print">
      <i class="material-icons">
          print
      </i>
    </router-link>
    <br>
    <watchnow />
  </span>
</span>
</template>

<script>
import watchnow from '@/components/watchnow.vue'
export default {
  methods: {
    toggleView () {
      this.$store.commit('toggleView')
    }
  },
  components: { watchnow: watchnow }
}
</script>

<style scoped>
.sched-app-pref-icons {
  flex: 1 1 auto;

  display: flex;
  /* flex-direction: column-reverse; */
}
.sched-app-pref-icons i {
  padding: 10px;
}

.sched-app-pref-icons span {
  width: 280px;
}
</style>
